import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { DOCUMENT } from "./actionTypes";

const INIT_STATE = {
  listaDocument: {
    totalRecords: 0,
    records: [],
  },
  loadingDocument: true,
  filterDocument: null,
  document: null,
  messageDocument: null,
  isDocumentSave: null,
  documentIdDuplicate: null,
  errorDocumentDuplicate: null,
  listaDocumentHistory: [],
  loadingDocumentHistory: true,
  errorLoadingDocument: null,
  errorLoadingDocumentHistory: null,
  loadingProducts: true,
  errorProducts: null,
  documentProducts: null,
  documentSections: null,
  loadingSections: true,
  errorSections: null,
  documentSnippets: null,
  loadingSnippets: true,
  errorSnippets: null,
  pageSizeDocument: DEFAULT_PAGE_SIZE,
  documentPreview: null,
  errorDocumentPreview: null,
  documentDownload: null,
  errorDocumentDownload: null,
  documentList: null,
  errorDocumentList: null,
  documentDownloadHistory: null,
  errorDocumentDownloadHistory: null,

  documentBulkStatusUpgrade: null,
  errorDocumentBulkStatusUpgrade: null,
};

const DocumentReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DOCUMENT.GET_LIST.REQUEST:
      return {
        ...state,
        filterDocument: action.payload,
        loadingDocument: true,
      };
    case DOCUMENT.GET_LIST.SUCCESS:
      return {
        ...state,
        listaDocument: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_LIST.FAIL:
      return {
        ...state,
        messageDocument: action.payload,
        loadingDocument: false,
      };

    case DOCUMENT.GET_DOCUMENT.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.GET_DOCUMENT.SUCCESS:
      return {
        ...state,
        document: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_DOCUMENT.FAIL:
      return {
        ...state,
        messageDocument: action.payload,
        loadingDocument: false,
        errorLoadingDocument: true,
      };

    case DOCUMENT.SAVE_DOCUMENT.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.SAVE_DOCUMENT.SUCCESS:
      return {
        ...state,
        isDocumentSave: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.SAVE_DOCUMENT.FAIL:
      return {
        ...state,
        loadingDocument: false,
        isDocumentSave: false,
        messageDocument: action.payload,
      };

    case DOCUMENT.LOAD_EMPTY:
      return {
        ...state,
        document: null,
        loadingDocument: false,
        errorLoadingDocument: null,
        errorLoadingDocumentHistory: null,
        documentPreview: null,
      };

    case DOCUMENT.CLEAN_MESSAGE:
      return {
        ...state,
        messageDocument: null,
        loadingDocument: false,
        isDocumentSave: null,
        documentPreview: null,
        documentDownload: null,
        errorDocumentDownload: null,
        documentList: null,
        documentDownloadHistory: null,
        errorDocumentDownloadHistory: null,
        documentBulkStatusUpgrade: null,
        errorDocumentBulkStatusUpgrade: null,
      };

    case DOCUMENT.GET_DOCUMENT_HISTORY.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.GET_DOCUMENT_HISTORY.SUCCESS:
      return {
        ...state,
        document: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_DOCUMENT_HISTORY.FAIL:
      return {
        ...state,
        loadingDocument: false,
        messageDocument: action.payload,
        errorLoadingDocumentHistory: false,
      };

    case DOCUMENT.GET_DOCUMENT_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingDocumentHistory: true,
      };
    case DOCUMENT.GET_DOCUMENT_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        listaDocumentHistory: action.payload,
        loadingDocumentHistory: false,
      };
    case DOCUMENT.GET_DOCUMENT_HISTORY_LIST.FAIL:
      return {
        ...state,
        errorLoadingDocumentHistory: true,
        loadingDocumentHistory: false,
      };

    case DOCUMENT.GET_DOCUMENT_PRODUCTS.REQUEST:
      return {
        ...state,
        loadingProducts: true,
      };
    case DOCUMENT.GET_DOCUMENT_PRODUCTS.SUCCESS:
      return {
        ...state,
        loadingProducts: false,
        documentProducts: action.payload,
      };
    case DOCUMENT.GET_DOCUMENT_PRODUCTS.FAIL:
      return {
        ...state,
        loadingProducts: false,
        errorProducts: action.payload,
      };

    case DOCUMENT.GET_DOCUMENT_SECTIONS.REQUEST:
      return {
        ...state,
        loadingSections: true,
      };
    case DOCUMENT.GET_DOCUMENT_SECTIONS.SUCCESS:
      return {
        ...state,
        loadingSections: false,
        documentSections: action.payload,
      };
    case DOCUMENT.GET_DOCUMENT_SECTIONS.FAIL:
      return {
        ...state,
        loadingSections: false,
        errorSections: action.payload,
      };

    case DOCUMENT.GET_DOCUMENT_SNIPPETS.REQUEST:
      return {
        ...state,
        loadingSnippets: true,
      };
    case DOCUMENT.GET_DOCUMENT_SNIPPETS.SUCCESS:
      return {
        ...state,
        loadingSnippets: false,
        documentSnippets: action.payload,
      };
    case DOCUMENT.GET_DOCUMENT_SNIPPETS.FAIL:
      return {
        ...state,
        loadingSnippets: false,
        errorSnippets: action.payload,
      };

    case DOCUMENT.DUPLICATE_DOCUMENT.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.DUPLICATE_DOCUMENT.SUCCESS:
      return {
        ...state,
        documentIdDuplicate: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.DUPLICATE_DOCUMENT.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentIdDuplicate: null,
        errorDocumentDuplicate: action.payload,
      };

    case DOCUMENT.DISABLE_LOADING_DOCUMENT:
      return {
        ...state,
        loadingDocumentHistory: false,
        loadingDocument: false,
      };

    case DOCUMENT.CLEAN_ID_DOCUMENT_DUPLICATE:
      return {
        ...state,
        documentIdDuplicate: null,
        loadingDocument: false,
      };

    case DOCUMENT.GET_DOCUMENT_PREVIEW.REQUEST:
      return {
        ...state,
        loadingDocument: true,
        errorDocumentPreview: null,
        documentPreview: null,
      };
    case DOCUMENT.GET_DOCUMENT_PREVIEW.SUCCESS:
      return {
        ...state,
        documentPreview: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_DOCUMENT_PREVIEW.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentPreview: false,
        errorDocumentPreview: action.payload,
      };

    case DOCUMENT.CHANGE_PAGE_SIZE_DOCUMENT:
      return {
        ...state,
        pageSizeDocument: action.payload,
      };

    case DOCUMENT.GET_DOWNLOAD_DOCUMENT.REQUEST:
      return {
        ...state,
        loadingDocument: true,
        errorDocumentDownload: null,
      };
    case DOCUMENT.GET_DOWNLOAD_DOCUMENT.SUCCESS:
      return {
        ...state,
        documentDownload: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_DOWNLOAD_DOCUMENT.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentDownload: null,
        errorDocumentDownload: action.payload,
      };

    case DOCUMENT.POST_DOCUMENT_DOWNLOAD_LIST.REQUEST:
      return {
        ...state,
        loadingDocument: true,
        errorDocumentList: null,
      };
    case DOCUMENT.POST_DOCUMENT_DOWNLOAD_LIST.SUCCESS:
      return {
        ...state,
        documentList: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.POST_DOCUMENT_DOWNLOAD_LIST.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentList: null,
        errorDocumentList: action.payload,
    };

    case DOCUMENT.GET_DOCUMENT_DOWNLOAD_HISTORY.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.GET_DOCUMENT_DOWNLOAD_HISTORY.SUCCESS:
      return {
        ...state,
        documentDownloadHistory: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.GET_DOCUMENT_DOWNLOAD_HISTORY.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentDownloadHistory: null,
        errorDocumentDownloadHistory: action.payload,
      };

    case DOCUMENT.PUT_DOCUMENT_BULK_STATUS_UPDATE.REQUEST:
      return {
        ...state,
        loadingDocument: true,
      };
    case DOCUMENT.PUT_DOCUMENT_BULK_STATUS_UPDATE.SUCCESS:
      return {
        ...state,
        documentBulkStatusUpgrade: action.payload,
        loadingDocument: false,
      };
    case DOCUMENT.PUT_DOCUMENT_BULK_STATUS_UPDATE.FAIL:
      return {
        ...state,
        loadingDocument: false,
        documentBulkStatusUpgrade: null,
        errorDocumentBulkStatusUpgrade: action.payload,
      };

    default:
      return state;
  }
};

export default DocumentReducer;
